var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import { ButtonModal, EditableDynamicTable, EditablePage, withGraphqlErrorFlags, withLoadingSpinner, withShowFlag, returnError, Field, isSufficientPermission, Permission, graphql, compose } from "@atlassiansox/microscopekit";
import styled from "styled-components";
import { withServiceNotFoundHandler } from "@atlassiansox/microscopekit/dist/src/error/with-service-not-found-handler";
import Button, { ButtonGroup } from "@atlaskit/button";
import CopyIcon from "@atlaskit/icon/glyph/copy";
import DownloadIcon from "@atlaskit/icon/glyph/download";
import serviceQuery from "./service-query.query.graphql"; // todo: remove keyValue from here and do query separately
import createKeyMutation from "./create-key.mutation.graphql";
import deleteKeyMutation from "./delete-key.mutation.graphql";
import generateKeypairMutation from "./generate-keypair.mutation.graphql";
import { CreateKeyForm } from "../components";
var KeyIDContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"])));
// Prod Microscope --> staging keyserver
// Dev/Stg Microscope --> dev keyserver
var Env = process.env.REACT_APP_ENV && process.env.REACT_APP_ENV.startsWith("prod")
    ? "staging"
    : "dev";
var KeyIDCellView = /** @class */ (function (_super) {
    __extends(KeyIDCellView, _super);
    function KeyIDCellView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KeyIDCellView.prototype.render = function () {
        var _this = this;
        return (React.createElement(KeyIDContainer, { key: this.props.value.keyId },
            React.createElement("span", null, this.props.value.keyId),
            React.createElement(Button, { iconBefore: React.createElement(CopyIcon, { label: "copyKey" }), spacing: "none", onClick: function (_) {
                    navigator.clipboard
                        .writeText(_this.props.value.keyValue)
                        .then(function () { return console.log("copied to clipboard"); }) // tslint:disable-line
                        .catch(function (e) { return console.log("failed to copy", e); }); // tslint:disable-line
                    // todo: show tooltip that says "Copied to clipboard!" on then()
                } }),
            React.createElement(Button, { href: "https://keyserver." + Env + ".atl-paas.net/public/" + this.props.value.keyId, iconBefore: React.createElement(DownloadIcon, { label: "downloadKey" }), spacing: "none" })));
    };
    return KeyIDCellView;
}(React.Component));
export { KeyIDCellView };
var KeyIDCellEdit = /** @class */ (function (_super) {
    __extends(KeyIDCellEdit, _super);
    function KeyIDCellEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KeyIDCellEdit.prototype.render = function () {
        return React.createElement(React.Fragment, null, this.props.defaultValue.keyId);
    };
    return KeyIDCellEdit;
}(React.Component));
var OtherCellEdit = /** @class */ (function (_super) {
    __extends(OtherCellEdit, _super);
    function OtherCellEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OtherCellEdit.prototype.render = function () {
        return React.createElement(React.Fragment, null, this.props.defaultValue);
    };
    return OtherCellEdit;
}(React.Component));
var AsapKeysView = /** @class */ (function (_super) {
    __extends(AsapKeysView, _super);
    function AsapKeysView(props) {
        var _this = _super.call(this, props) || this;
        _this.editableFields = [
            {
                key: "id",
                headContent: "Key ID",
                isSortable: true,
                isDefaultSortKey: true,
                defaultSortOrder: "ASC",
                editableContent: (React.createElement(KeyIDCellEdit, { isDisabled: true, defaultValue: "", onChange: function () { } })),
                viewContent: React.createElement(KeyIDCellView, null)
            },
            {
                key: "createdOn",
                headContent: "Created On",
                isSortable: true,
                editableContent: (React.createElement(OtherCellEdit, { isDisabled: true, defaultValue: "", onChange: function () { } }))
            },
            {
                key: "createdBy",
                headContent: "Created By",
                isSortable: true,
                editableContent: (React.createElement(OtherCellEdit, { isDisabled: true, defaultValue: "", onChange: function () { } }))
            }
        ];
        _this.deleteRemovedKeys = function (data) { return __awaiter(_this, void 0, void 0, function () {
            var allKeyIds, remainingKeyIds, keysToDelete, promises, _a, message, graphQLErrors, errMsg;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        allKeyIds = this.props
                            .data.service.asapKeys.node.filter(this.notEmpty)
                            .map(function (key) { return key.id; });
                        remainingKeyIds = data.keys.map(function (el) { return el.key; });
                        keysToDelete = allKeyIds.filter(function (x) { return !remainingKeyIds.includes(x); });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        promises = keysToDelete.map(function (keyId) { return __awaiter(_this, void 0, void 0, function () {
                            var updatedService;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.props.deleteAsapKey({
                                            variables: {
                                                id: keyId
                                            }
                                        })];
                                    case 1:
                                        updatedService = _a.sent();
                                        return [2 /*return*/, updatedService];
                                }
                            });
                        }); });
                        return [4 /*yield*/, Promise.all(promises)];
                    case 2:
                        _b.sent();
                        this.props.showFlag({
                            type: "success",
                            title: "Success",
                            message: "ASAP Key(s) deleted."
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        message = _a.message, graphQLErrors = _a.graphQLErrors;
                        errMsg = returnError(graphQLErrors, message)[0];
                        this.props.showFlag({
                            type: "error",
                            title: "Error",
                            message: errMsg
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.createNewKey = function (data) { return __awaiter(_this, void 0, void 0, function () {
            var updatedService, _a, message, graphQLErrors, errMsg;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!data.createKeyForm) return [3 /*break*/, 4];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.props.createAsapKey({
                                variables: {
                                    input: {
                                        id: data.createKeyForm.keyId,
                                        keyValue: data.createKeyForm.publicKeyPem,
                                        serviceId: this.props.data.service.id
                                    }
                                }
                            })];
                    case 2:
                        updatedService = _b.sent();
                        if (updatedService) {
                            this.props.showFlag({
                                type: "success",
                                title: "Success",
                                message: "New ASAP Key added."
                            });
                        }
                        else {
                            this.props.showFlag({
                                type: "error",
                                title: "Error",
                                message: "Create asap key request did return updated service"
                            });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        message = _a.message, graphQLErrors = _a.graphQLErrors;
                        errMsg = returnError(graphQLErrors, message)[0];
                        this.props.showFlag({
                            type: "error",
                            title: "Error",
                            message: errMsg
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    AsapKeysView.prototype.componentDidMount = function () {
        document.title = this.props.data.service.id + " | ASAP Keys";
    };
    AsapKeysView.prototype.componentWillUnmount = function () {
        document.title = "Microscope";
    };
    AsapKeysView.prototype.notEmpty = function (value) {
        return value !== null && value !== undefined;
    };
    AsapKeysView.prototype.render = function () {
        var _this = this;
        var service = this.props.data.service;
        var keyNodes = service.asapKeys.node;
        var keys = keyNodes.filter(this.notEmpty);
        var keysToDisplay = keys.map(function (key) { return ({
            key: key.id,
            id: {
                keyId: key.id,
                keyValue: key.keyValue
            },
            createdOn: key.createdOn,
            createdBy: key.createdBy && key.createdBy.id ? key.createdBy.id : "probably-micros"
        }); });
        var newKeyButton = (React.createElement(ButtonGroup, null,
            React.createElement(ButtonModal, { buttonText: "Create Key", heading: "Add a new ASAP Key", actions: {
                    submit: {
                        text: "Save",
                        onSubmit: this.createNewKey
                    },
                    close: {
                        text: "Close"
                    }
                } },
                React.createElement(Field, { name: "createKeyForm", defaultValue: {} }, function (_a) {
                    var fieldProps = _a.fieldProps;
                    return (React.createElement(CreateKeyForm, __assign({}, fieldProps, { serviceId: service.id, generateKeypair: _this.props.generateKeypair, showFlag: _this.props.showFlag })));
                }))));
        return (React.createElement(EditablePage, { title: "ASAP Keys", onSave: this.deleteRemovedKeys, isEditable: isSufficientPermission(service.currentUserPermission, Permission.Write), actions: isSufficientPermission(service.currentUserPermission, Permission.Write)
                ? newKeyButton
                : undefined },
            React.createElement(EditableDynamicTable, { name: "keys", fields: this.editableFields, defaultValue: keysToDisplay, allowDelete: function () { return true; }, emptyView: React.createElement("div", null, "This service has no ASAP Keys") })));
    };
    return AsapKeysView;
}(React.Component));
export { AsapKeysView };
// Use the `compose` function to wrap decorators around your component. These will run before your component code does.
export var AsapKeysPage = compose(graphql(serviceQuery, {}), graphql(createKeyMutation, {
    name: "createAsapKey"
}), graphql(deleteKeyMutation, {
    name: "deleteAsapKey"
}), graphql(generateKeypairMutation, {
    name: "generateKeypair"
}), withLoadingSpinner, withShowFlag, withGraphqlErrorFlags, withServiceNotFoundHandler)(AsapKeysView);
var templateObject_1;
